import { gql } from '@apollo/client';

const GET_ENTITY_TYPES_QUERY = gql`
  {
    entityTypes {
      id
      fieldName
    }
  }
`;
export default GET_ENTITY_TYPES_QUERY;
